import { useMiiaFwStore } from '@/stores/miiaFwStore'

export const useLoadingView = () => {
  // /**
  //  * ローディング画面を表示/表示解除する。
  //  * @param isLanding trueならロード中を表示にし、falseなら解除する。
  //  * @param message ロード中に表示されるメッセージの文字列。
  //  */
  const setLoadingView = (isLanding: boolean, message: string = '処理中'): void => {
    const miiaFwStore = useMiiaFwStore()
    if (isLanding) {
      miiaFwStore.enableLoadingView(message)
    } else {
      miiaFwStore.disableLoadingView()
    }
  }
  return {
    setLoadingView
  }
}
